import { useEffect, useState } from 'react'
import axios from 'services/axios'
import { IActivityTopBarStatisticsData, getActivityTopBarStatisticsData } from './utils'
import { useParams } from 'react-router-dom'
import { CurrentZone, ElasticRange } from 'utils/types'
import { useSelector } from 'react-redux'
import { selectCurrentZone } from 'store/global'

interface Period {
  start: string
  end: string
}

const useTopBarStatistics = ({
  period,
  filters,
  range,
}: {
  period: Period | null
  filters: Record<string, string>[]
  range?: ElasticRange
}) => {
  const { entityId } = useParams<{ entityId: string }>()
  const currentZone: CurrentZone = useSelector(selectCurrentZone)

  const [data, setData] = useState<IActivityTopBarStatisticsData | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    axios
      .get(`crypto/main-statistics/${entityId}`, {
        params: {
          zone: currentZone.cryptoActivityIndices,
          period,
          filters: JSON.stringify(filters),
          range: range ? JSON.stringify(range) : undefined,
        },
      })
      .then(res => setData(res.data))
      .catch(err => {
        console.error(err)
      })
      .finally(() => setIsLoading(false))
  }, [entityId, currentZone.cryptoActivityIndices, period, filters, range])

  return {
    data: data ? getActivityTopBarStatisticsData(data) : null,
    isLoading,
  }
}

export default useTopBarStatistics
